// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UserListMenu-cls1___a583d10b5dbd557ecdc{/*!*/}.UserListMenu-cls2___8cd999dce7a0ea059f7{max-height:208px;width:100%}.UserListMenu-cls2___8cd999dce7a0ea059f7 a{color:currentColor;text-decoration:none}.UserListMenu-cls2___8cd999dce7a0ea059f7 ul{list-style:none;margin:0;padding:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "UserListMenu-cls1___a583d10b5dbd557ecdc",
	"cls2": "UserListMenu-cls2___8cd999dce7a0ea059f7 UserListMenu-cls1___a583d10b5dbd557ecdc"
};
export default ___CSS_LOADER_EXPORT___;
